<template>
  <v-container class="py-0 px-6" fluid>
    <v-row>
      <v-col cols="8">
        <h3 class="mb-2">{{ title }}</h3>
        <v-tooltip top :disabled="!disabled">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-text-field
                v-if="creditsValue"
                key="withMask"
                v-model="creditsValue"
                v-money="{ thousands: '.', precision: 0 }"
                autofocus
                :disabled="disabled"
                label="Quantidade"
                outlined
                :error-messages="getSafe(() => validations) ? 'Defina a quantidade de disparos disponíveis para este canal.' : ''"
              />
              <v-text-field
                v-if="!creditsValue"
                key="withoutMask"
                v-model="creditsValue"
                autofocus
                :disabled="disabled"
                label="Quantidade"
                placeholder="Quantidade"
                outlined
                :error-messages="getSafe(() => validations) ? 'Defina a quantidade de disparos disponíveis para este canal.' : ''"
              />
            </div>
          </template>
          <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
          <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
        </v-tooltip>
      </v-col>
      <v-col v-if="haveCurrentBalance" cols="4">
        <h3>Saldo atual</h3>
        <div class="credits-container">
          <p>{{ localeString(balance) }} créditos</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { VMoney } from 'v-money'

import { QUERY_GET_CREDITS as QUERY_GET_SMS_CREDITS } from '@/modules/campanhas/campanhas-sms/graphql'
import { QUERY_GET_CREDITS as QUERY_GET_EMAIL_CREDITS } from '@/modules/campanhas/campanhas-email/graphql'

export default {
  name: 'CreditEntry',

  directives: { money: VMoney },

  props: {
    title: {
      type: String,
      default: () => '',
    },
    channelType: {
      type: String,
      required: true,
      validator: (channel) => ['sms', 'whatsapp', 'email', 'push'].includes(channel),
    },
    credits: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validations: {
      type: String,
      default: () => '',
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    balance: 0,
  }),

  computed: {
    disabledFieldTooltip() {
      const status = this.isMariaCampaignFinished ? 'concluída' : 'ativa'
      return `Não é possível alterar essa configuração em uma campanha ${status}.`
    },
    creditsValue: {
      get() {
        return this.credits
      },
      set(value) {
        this.$emit('update:credits', value)
      },
    },
    queryGetCredits() {
      return this.channelType === 'sms' ? QUERY_GET_SMS_CREDITS : QUERY_GET_EMAIL_CREDITS
    },
    haveCurrentBalance() {
      return ['sms', 'email'].includes(this.channelType)
    },
  },

  mounted() {
    if (this.haveCurrentBalance) this.getCredits()
  },

  methods: {
    async getCredits() {
      await this.$apollo
        .query({
          query: this.queryGetCredits,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { balance } }) => {
          this.balance = balance
        })
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  color: $cinza-d20;
  font-weight: 400;
}
</style>
